import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationModal } from "@components/common";
import { Stack, Typography } from "@components/base";

interface SessionExpiredModal {
  open: boolean;
  onClose: () => void;
}

const SessionExpiredModal: FC<SessionExpiredModal> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const handleConfirm = (): void => {
    window.open(import.meta.env.VITE_CSOB_LOGIN_LINK, "_blank");
    onClose();
  };

  const handleClose = (): void => {
    onClose();
  };

  return (
    <ConfirmationModal
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={t("csob.questionnaires.sessionExpired.title")}
      description={
        <Stack spacing={2} mt={2} textAlign="left">
          <Typography color="text.secondary">
            {t("csob.questionnaires.sessionExpired.description")}
          </Typography>
          <ol>
            <li>{t("csob.questionnaires.sessionExpired.step1")}</li>
            <li>{t("csob.questionnaires.sessionExpired.step2")}</li>
            <li>{t("csob.questionnaires.sessionExpired.step3")}</li>
          </ol>
        </Stack>
      }
      confirmText={t("csob.questionnaires.sessionExpired.loginButton")}
    />
  );
};

export default SessionExpiredModal;
